import Vue from 'vue';
import Router from 'vue-router';

export default () => {
  Vue.use(Router);

  const searchIcsParams = 'industrial|office|shops';

  const router = new Router({
    mode: 'history',
    base: '/ics/property/openday',
    routes: [
      {
        name: 'opendayList',
        path: `/:p1(${searchIcsParams})?/`,
        props: route => ({
          queryKeyword: route.query,
        }),
        component: () => import('./search'),
      },
    ],
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
  });

  return router;
};
